import { Dispatch, FC, JSX, SetStateAction } from 'react';

import { Button, Flex, Form, FormListFieldData } from 'antd';
import classNames from 'classnames';

import { TVerticalTableProps, VerticalTable } from '@/components/vertical-table';

import styles from './DebtsMobileTable.module.scss';

import { BusinessDebtDto } from '@/generated-types';
import { getFormattedAmount } from '@/utils';

type TDebtsMobileTableProps = Omit<TVerticalTableProps<FormListFieldData>, 'rowKey'> & {
	setEditingRowId: Dispatch<SetStateAction<number>>;
	add: () => void;
};

export const DebtsMobileTable: FC<TDebtsMobileTableProps> = ({
	columns,
	dataSource,
	setEditingRowId,
	add,
}): JSX.Element => {
	const form = Form.useFormInstance();
	const businessDebts = Form.useWatch('businessDebts', form) || [];

	const totalCurrentDebtBalance = businessDebts.reduce(
		(sum: number, row: BusinessDebtDto) => sum + (Number(row?.outstandingBalance) || 0),
		0,
	);
	const totalMonthlyPayment = businessDebts.reduce(
		(sum: number, row: BusinessDebtDto) => sum + (Number(row?.regularPayment) || 0),
		0,
	);

	const totalFormattedCurrentDebtBalance = getFormattedAmount(totalCurrentDebtBalance);
	const totalFormattedMonthlyPayment = getFormattedAmount(totalMonthlyPayment);

	return (
		<>
			<VerticalTable
				columns={columns}
				dataSource={dataSource}
				rowKey="name"
				onColumn={{
					onClick: (record) => setEditingRowId(record.name),
				}}
			/>
			<Flex className={styles['total-container']} gap={8}>
				<Flex className={styles['total']} vertical>
					<span>Total Current Debt Balance:</span>
					<span>Total Monthly Payment:</span>
				</Flex>
				<Flex className={classNames(styles['total'], styles['amount'])} vertical>
					<span>{totalFormattedCurrentDebtBalance}</span>
					<span>{totalFormattedMonthlyPayment}</span>
				</Flex>
			</Flex>
			<Flex className={styles['add-button-container']} justify="flex-end">
				<Button className={styles['add-button']} type="primary" onClick={add}>
					Add Debt
				</Button>
			</Flex>
		</>
	);
};
